import { types } from '../../actions/automation'

export default function reducer(state = {}, action: any = {}) {
  switch (action.type) {
    case types.SELECT_ACTION:
      return {
        ...state,
        selectedAction: action.actionName
      }
    case types.SELECT_EVENT:
      return {
        ...state,
        selectedEvent: action.eventName
      }
    default:
      return state
  }
}